import { COLORS, HERO_IMAGE } from '@/constants';

type Translate = (key: string) => string;

export function WalletHero({ t }: { t: Translate }) {
  return (
    <div className="relative min-h-[250px] overflow-hidden">
      <img src={HERO_IMAGE} alt={t('auth.heroImageAlt')} className="absolute inset-0 h-full w-full object-cover object-center" />
      <div className="absolute inset-x-0 bottom-0 h-6 bg-gradient-to-b from-transparent to-[#010802]" />
      <div className="relative z-10 flex min-h-[250px] max-w-[220px] flex-col items-start justify-center gap-2 pl-6">
        <div className="text-xs font-medium uppercase" style={{ color: COLORS.iconGlobal }}>{t('auth.welcomeTo')}</div>
        <div className="flex items-center gap-1 text-[34px] font-bold leading-none">
          <span style={{ background: COLORS.orbText, backgroundClip: 'text', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>ORB</span>
          <span style={{ color: COLORS.lightYellow, textShadow: COLORS.textShadow }}>{t('auth.orbTitle')}</span>
        </div>
        <div className="flex flex-col gap-1">
          <div className="text-sm leading-snug" style={{ color: COLORS.iconGlobal }}>{t('auth.slogan1')}</div>
          <div className="text-sm leading-snug" style={{ color: COLORS.iconGlobal }}>{t('auth.slogan2')}</div>
        </div>
      </div>
    </div>
  );
}